import NL_TRANSLATIONS from "./nl.json";

const TRANSLATIONS = {
  nl: NL_TRANSLATIONS,
};

export const LOCALES = ["nl"];
export const DEFAULT_LOCALE = "nl";

export default class I18n {
  constructor() {
    this.locale = "nl";
  }

  /**
   * Resolve the translation
   *
   * @param {string | Array<string>} key_or_keys - The key to translate, or an array of keys
   * @param {Record<string, string>} interpolations - Values to be filled in the translation
   * @returns string
   */
  t(key_or_keys, interpolations = {}) {
    const keys = Array.isArray(key_or_keys)
      ? key_or_keys
      : key_or_keys.split(".");
    let translation = keys.reduce((scope, key) => {
      if (scope) return scope[key];
    }, TRANSLATIONS[this.locale]);

    if (translation === undefined) {
      // This should only happen during development
      // eslint-disable-next-line no-console
      console.error(`Translation ${keys.join(".")} could not be found`);
    } else if (typeof translation === "string") {
      Object.entries(interpolations).forEach(
        ([key, value]) =>
          (translation = translation.replaceAll(`{{${key}}}`, value)),
      );
    }

    return translation;
  }
}

export function translatedPropertyFromKey(translation_key, interpolations) {
  return LOCALES.reduce((acc, locale) => {
    return Object.assign(acc, {
      [locale]: new I18n().t(translation_key, interpolations),
    });
  }, {});
}
